/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_change_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does percentage change use the original value as the denominator?`)
};

const es_pct_change_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué el cambio porcentual usa el valor original como denominador?`)
};

const de_pct_change_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum verwendet die prozentuale Veränderung den Ausgangswert als Nenner?`)
};

const nl_pct_change_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom gebruikt percentageverandering de oorspronkelijke waarde als noemer?`)
};

const fr_pct_change_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi la variation en pourcentage utilise-t-elle la valeur d’origine comme dénominateur ?`)
};

const it_pct_change_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché la variazione percentuale usa il valore originale come denominatore?`)
};

const pt_br2_pct_change_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que a variação percentual usa o valor original como denominador?`)
};

const pt_pct_change_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que a variação percentual usa o valor original como denominador?`)
};

const ja_pct_change_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント変化はなぜ元の値を分母に使うのですか？`)
};

const zh_pct_change_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么百分比变化用原始值作分母？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_change_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_change_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_change_faq4_q", locale)
	if (locale === "en") return en_pct_change_faq4_q(inputs)
	if (locale === "es") return es_pct_change_faq4_q(inputs)
	if (locale === "de") return de_pct_change_faq4_q(inputs)
	if (locale === "nl") return nl_pct_change_faq4_q(inputs)
	if (locale === "fr") return fr_pct_change_faq4_q(inputs)
	if (locale === "it") return it_pct_change_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_change_faq4_q(inputs)
	if (locale === "pt") return pt_pct_change_faq4_q(inputs)
	if (locale === "ja") return ja_pct_change_faq4_q(inputs)
	return zh_pct_change_faq4_q(inputs)
};